import { Article, Artist, Comic, ReadStatus, Release } from "../types";
import { buildReaderUrl } from "./buildReaderUrl";
import { safeParseUrl, toPathname } from "./safeParseUrl";

const ctaFunctions: {
  [key: string]: (content: any) => string;
} = {
  Comic: getSeriesCTA,
  Release: getReleaseCTA,
  Artist: getArtistCTA,
  News: getNewsCTA,
};
export function getCTAUrl(content: Comic | Release | Artist | Article) {
  return ctaFunctions[content.entity_type](content);
}

function getSeriesCTA(content: Comic) {
  if (content.user_read_status?.uuid) {
    return getReadURL(content.read_url, content.user_read_status);
  }
  if (content.hasOwnProperty("first_release_uuid")) {
    return "/read/" + content.first_release_uuid + "/1";
  }
  return getReadURL(content.read_url, content.user_read_status);
}

function getReleaseCTA(content: Release) {
  if (content.read_url) {
    return getReadURL(content.read_url, content.user_read_status);
  }

  return (
    "/read/" +
    content.key +
    `/${content.user_read_status?.last_page_read ?? 1}`
  );
}

function getArtistCTA(content: Artist) {
  return toPathname(content.url);
}

function getNewsCTA(content: Article) {
  return toPathname(content.url);
}

export function getReadURL(
  readUrl: string,
  userReadStatus?: ReadStatus | null,
) {
  return buildReaderUrl(
    safeParseUrl(readUrl)?.pathname ?? readUrl,
    userReadStatus?.uuid,
    userReadStatus?.last_page_read,
  );
}
